




























































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { NoCache } from '@/decorators/NoCache'

@Component({
  components: { Icon },
  props: {
    fullHeight: {
      type: Boolean,
      default: false
    },
    headerClasses: {
      type: String,
      default: ''
    },
    hrClasses: {
      type: String,
      default: ''
    },
    enableToggle: {
      type: Boolean,
      default: false
    },
    togglePosition: {
      type: String,
      default: 'right'
    },
    showShadow: {
      type: Boolean,
      default: true
    },
    defaultVisible: {
      type: Boolean,
      default: true
    }
  }
})
export default class Card extends Vue {
  isVisible: boolean = this.$props.defaultVisible
  overflowHidden: boolean = false

  mounted () {
    if (!this.showHeader) {
      this.setOverflow(false)
    }
  }

  @NoCache
  get showHeader () {
    return !!this.$slots.header || this.$props.enableToggle
  }

  setOverflow (value: boolean) {
    this.overflowHidden = value
  }

  toggleVisibility () {
    if (this.$props.enableToggle) {
      this.isVisible = !this.isVisible
      if (this.isVisible) {
        this.$emit('toggleOpen')
      } else {
        this.$emit('toggleClose')
      }
    }
  }

  // do not remove!
  open () {
    this.isVisible = true
    this.$emit('toggleOpen')
  }

  // do not remove!
  collapse () {
    this.isVisible = false
    this.$emit('toggleClose')
  }
}
